{
  "schema": "SYNERGY_PROVIDER_OBSERVABILITY_DASHBOARD_V1",
  "generated_at": "2026-08-01T12:00:00Z",
  "environment": "NONPRODUCTION_ONLY",
  "summary": {
    "provider_model_count": 4,
    "eligible_count": 0,
    "health_state_counts": {
      "HEALTHY": 2,
      "DEGRADED": 1,
      "UNAVAILABLE": 1,
      "STALE": 0
    }
  },
  "providers": [
    {
      "schema": "SYNERGY_PROVIDER_OBSERVABILITY_VIEW_V1",
      "provider_id": "synthetic-free-lab",
      "model_id": "synthetic-text-32k",
      "display_name": "Synthetic Free Lab",
      "profile_id": "synthetic-free-text-v1",
      "registry_version": "offline-fixture-1",
      "priority_tier": "FREE",
      "access_mode": "API",
      "billing_class": "FREE",
      "capabilities": ["structured_text", "document", "review"],
      "allowed_data_classes": ["PUBLIC", "SANITIZED"],
      "allowed_risk_classes": ["LOW"],
      "modalities": ["TEXT"],
      "maximum_context_tokens": 32768,
      "benchmark": {
        "benchmark_id": "synthetic-benchmark-free-001",
        "workload_profile_id": "structured-text-v1",
        "score": 92.4,
        "state": "PASS",
        "sample_count": 24,
        "input_scope": "SYNTHETIC",
        "generated_at": "2026-08-01T11:00:00Z",
        "valid_until": "2026-08-08T11:00:00Z",
        "fresh": true,
        "components": {"correctness": 0.95, "completeness": 0.92, "hallucination_inverse": 0.96},
        "metric_values": {"correctness": 0.95, "completeness": 0.92, "hallucination_rate": 0.04},
        "latency_p95_ms": 740,
        "cost_per_accepted_result_usd": 0,
        "evidence_digest": "sha256:aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa"
      },
      "health": {
        "health_id": "synthetic-health-free-001",
        "score": 94.1,
        "state": "HEALTHY",
        "sample_count": 60,
        "observed_at": "2026-08-01T11:55:00Z",
        "valid_until": "2026-08-01T12:10:00Z",
        "fresh": true,
        "components": {"success": 0.98, "timeout_inverse": 0.97, "rate_limit_inverse": 0.94, "latency_slo": 0.9},
        "circuit_state": "CLOSED",
        "quota_state": "AVAILABLE",
        "latency_p95_ms": 690,
        "latency_slo_ms": 1000,
        "evidence_digest": "sha256:bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb"
      },
      "eligibility": {
        "route_eligible": false,
        "blockers": ["AUTOMATIC_ROUTE_DISABLED"],
        "minimum_quality_score": 80,
        "minimum_health_score": 85,
        "automatic_route_allowed": false,
        "human_authority_required": false
      }
    },
    {
      "schema": "SYNERGY_PROVIDER_OBSERVABILITY_VIEW_V1",
      "provider_id": "synthetic-codex-seat",
      "model_id": "synthetic-code-review",
      "display_name": "Synthetic Codex Seat",
      "profile_id": "synthetic-codex-code-v1",
      "registry_version": "offline-fixture-1",
      "priority_tier": "CODEX",
      "access_mode": "CODEX_SEAT",
      "billing_class": "EXISTING_QUOTA",
      "capabilities": ["code", "review", "structured_text"],
      "allowed_data_classes": ["PUBLIC", "SANITIZED"],
      "allowed_risk_classes": ["LOW", "MEDIUM"],
      "modalities": ["TEXT", "CODE"],
      "maximum_context_tokens": 65536,
      "benchmark": {
        "benchmark_id": "synthetic-benchmark-codex-001",
        "workload_profile_id": "code-review-v1",
        "score": 88.6,
        "state": "PASS",
        "sample_count": 20,
        "input_scope": "SYNTHETIC",
        "generated_at": "2026-08-01T11:00:00Z",
        "valid_until": "2026-08-08T11:00:00Z",
        "fresh": true,
        "components": {"correctness": 0.91, "completeness": 0.88, "code_test_pass": 0.9, "hallucination_inverse": 0.87},
        "metric_values": {"correctness": 0.91, "completeness": 0.88, "code_test_pass_rate": 0.9, "hallucination_rate": 0.13},
        "latency_p95_ms": 1300,
        "cost_per_accepted_result_usd": 0,
        "evidence_digest": "sha256:cccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccc"
      },
      "health": {
        "health_id": "synthetic-health-codex-001",
        "score": 78.2,
        "state": "DEGRADED",
        "sample_count": 40,
        "observed_at": "2026-08-01T11:55:00Z",
        "valid_until": "2026-08-01T12:10:00Z",
        "fresh": true,
        "components": {"success": 0.87, "timeout_inverse": 0.82, "rate_limit_inverse": 0.7, "latency_slo": 0.75},
        "circuit_state": "HALF_OPEN",
        "quota_state": "CONSERVE",
        "latency_p95_ms": 1450,
        "latency_slo_ms": 1500,
        "evidence_digest": "sha256:dddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddd"
      },
      "eligibility": {
        "route_eligible": false,
        "blockers": ["HEALTH_BELOW_THRESHOLD", "AUTOMATIC_ROUTE_DISABLED"],
        "minimum_quality_score": 85,
        "minimum_health_score": 85,
        "automatic_route_allowed": false,
        "human_authority_required": false
      }
    },
    {
      "schema": "SYNERGY_PROVIDER_OBSERVABILITY_VIEW_V1",
      "provider_id": "synthetic-low-cost-reserve",
      "model_id": "synthetic-document-long",
      "display_name": "Synthetic Low-cost Reserve",
      "profile_id": "synthetic-paid-document-v1",
      "registry_version": "offline-fixture-1",
      "priority_tier": "LOW_COST_PAID",
      "access_mode": "API",
      "billing_class": "LOW_COST_PAID",
      "capabilities": ["document", "structured_text"],
      "allowed_data_classes": ["PUBLIC"],
      "allowed_risk_classes": ["LOW"],
      "modalities": ["TEXT"],
      "maximum_context_tokens": 131072,
      "benchmark": {
        "benchmark_id": "synthetic-benchmark-paid-001",
        "workload_profile_id": "document-long-v1",
        "score": 82.5,
        "state": "STALE",
        "sample_count": 18,
        "input_scope": "SYNTHETIC",
        "generated_at": "2026-07-01T11:00:00Z",
        "valid_until": "2026-07-08T11:00:00Z",
        "fresh": false,
        "components": {"correctness": 0.85, "completeness": 0.84, "hallucination_inverse": 0.78},
        "metric_values": {"correctness": 0.85, "completeness": 0.84, "hallucination_rate": 0.22},
        "latency_p95_ms": 920,
        "cost_per_accepted_result_usd": 0.01,
        "evidence_digest": "sha256:eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"
      },
      "health": {
        "health_id": "synthetic-health-paid-001",
        "score": 90.3,
        "state": "HEALTHY",
        "sample_count": 55,
        "observed_at": "2026-08-01T11:55:00Z",
        "valid_until": "2026-08-01T12:10:00Z",
        "fresh": true,
        "components": {"success": 0.96, "timeout_inverse": 0.93, "rate_limit_inverse": 0.88, "latency_slo": 0.9},
        "circuit_state": "CLOSED",
        "quota_state": "AVAILABLE",
        "latency_p95_ms": 900,
        "latency_slo_ms": 1200,
        "evidence_digest": "sha256:ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"
      },
      "eligibility": {
        "route_eligible": false,
        "blockers": ["BENCHMARK_STALE", "AUTOMATIC_ROUTE_DISABLED"],
        "minimum_quality_score": 80,
        "minimum_health_score": 85,
        "automatic_route_allowed": false,
        "human_authority_required": true
      }
    },
    {
      "schema": "SYNERGY_PROVIDER_OBSERVABILITY_VIEW_V1",
      "provider_id": "synthetic-human-assisted",
      "model_id": "synthetic-manual-review",
      "display_name": "Synthetic Human-assisted Seat",
      "profile_id": "synthetic-human-review-v1",
      "registry_version": "offline-fixture-1",
      "priority_tier": "HUMAN_ASSISTED",
      "access_mode": "HUMAN_ASSISTED",
      "billing_class": "HUMAN_SEAT",
      "capabilities": ["independent_review"],
      "allowed_data_classes": ["PUBLIC", "SANITIZED"],
      "allowed_risk_classes": ["LOW", "MEDIUM"],
      "modalities": ["TEXT"],
      "maximum_context_tokens": 16384,
      "benchmark": {
        "benchmark_id": "synthetic-benchmark-human-001",
        "workload_profile_id": "independent-review-v1",
        "score": 68.5,
        "state": "INSUFFICIENT",
        "sample_count": 3,
        "input_scope": "SYNTHETIC",
        "generated_at": "2026-08-01T11:00:00Z",
        "valid_until": "2026-08-08T11:00:00Z",
        "fresh": true,
        "components": {"correctness": 0.75, "completeness": 0.7, "hallucination_inverse": 0.6},
        "metric_values": {"correctness": 0.75, "completeness": 0.7, "hallucination_rate": 0.4},
        "latency_p95_ms": 6200,
        "cost_per_accepted_result_usd": 0,
        "evidence_digest": "sha256:1111111111111111111111111111111111111111111111111111111111111111"
      },
      "health": {
        "health_id": "synthetic-health-human-001",
        "score": 45,
        "state": "UNAVAILABLE",
        "sample_count": 10,
        "observed_at": "2026-08-01T11:55:00Z",
        "valid_until": "2026-08-01T12:10:00Z",
        "fresh": true,
        "components": {"success": 0.5, "timeout_inverse": 0.6, "rate_limit_inverse": 0.4, "latency_slo": 0.2},
        "circuit_state": "OPEN",
        "quota_state": "EXHAUSTED",
        "latency_p95_ms": 6500,
        "latency_slo_ms": 3000,
        "evidence_digest": "sha256:2222222222222222222222222222222222222222222222222222222222222222"
      },
      "eligibility": {
        "route_eligible": false,
        "blockers": ["BENCHMARK_SAMPLE_INSUFFICIENT", "PROVIDER_CIRCUIT_OPEN", "PROVIDER_QUOTA_EXHAUSTED", "AUTOMATIC_ROUTE_DISABLED"],
        "minimum_quality_score": 80,
        "minimum_health_score": 85,
        "automatic_route_allowed": false,
        "human_authority_required": true
      }
    }
  ],
  "safety": {
    "provider_calls": 0,
    "provider_spend_usd": 0,
    "secret_value_access": false,
    "raw_prompt_storage": false,
    "raw_customer_data_storage": false,
    "chain_of_thought_storage": false
  }
}
